<template>
  <section class="plan-info-container">
    <div>
      <div class="flex flex-algin">
        <span
          class="icon icon-content">
          <img
            :src="formData.company_logo"
            alt="company"/>
        </span>
        <span
          class="icon icon-content"
        >
          <font-awesome-icon
            v-if="formData.class_id"
            :icon="getOptionName('iconOptions', formData.class_id)" />
        </span>
        <span class="label break-work">{{ formData.plan }}</span>
      </div>
      <v-button
        type="info"
        @click="planClick">Plan Info</v-button>
      <plan-quote-info
        :amount="formData.amount"
        :formData="formData.quote_coverage_list" />
      <code-select
        v-if="formData.use_code!=0"
        :orderId="orderId"
        :isQuote="false"
        :is-fina="isFina"
        :isSpon="isSpon"
        :customerId="formData.customer_id"
        :customer="formData.customer"
        :isUser="true"
        :useCode="formData.use_code"
        @check-code="handlerApplyCode"></code-select>
    </div>
    <plan-dialog
      ref="plan-dialog"
      :planInfo="formData.quote_coverage_list" />
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import PlanDialog from '@/views/quoting/dialogs/plan-dialog'
import {applyOrderCode, verifyPromoCode} from '@/api/order'
import CodeSelect from '@/views/components/code-select'
import PlanQuoteInfo from '@/views/components/plan-quote-info'
import {mapActions, mapState} from 'vuex'

export default {
  name: 'PlanInfo',
  components: {
    PlanDialog,
    // PromoCode,
    PlanQuoteInfo,
    CodeSelect
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    codeType: {
      type: String,
      default: ''
    },
    isFina: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: [String,Number],
      default: ''
    },
  },
  data() {
    return {
      formData: {
        code_disc_prm: '',
        code_disc_pct: '',
      },
      code: '',
      isFirst:true
    }
  },
  computed: {
    ...mapState('coupon', ['selectCode']),
    orderId() {
      return this.formData.id
    },
    isSpon(){
      let { quote_coverage_list} = this.formData||{}
      let {plan_info={}} =quote_coverage_list||{}
      let {is_sponsor=''} = plan_info||{}
      return is_sponsor==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    ...mapActions('coupon', ['setCouponData','setSelectCode']),
    handlerApplyCode(data) {
      // this.formData = Object.assign(this.formData, data)
      // this.$emit('apply', data)
      this.network().applyOrderCode()
    },
    planClick() {
      this.$refs['plan-dialog'].changeDialog()
    },
    network() {
      return {
        verifyPromoCode: async () => {
          const { data } = await verifyPromoCode({
            customer_id: this.formData.customer_id,
            code: this.code
          })
          if(data.code == 1000) {
            this.network().applyOrderCode()
          }
        },
        applyOrderCode: async () => {
          let {selectCode, code, coupon} = this.selectCode||{}
          let params = {}
          if(coupon&&coupon.selectCode==1)params.coupon_code = coupon&&coupon.coupon_code
          if(code&&code.selectCode==2)params.code = code&&code.code

          const { data } = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.formData.customer_id,
            ...params
          })
          // this.formData.amount = data.amount
          this.formData = Object.assign(this.formData, data)
          this.$emit('apply', this.formData )
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-info-container{
  width: 280px;
}
  .flex-algin {
    //align-items: center;
    margin-bottom: 10px;
    width: 280px;

    .label {
      margin-top: 0;
      word-break: break-word;
    }

    .icon {
      margin-right: 15px;
      height: 22px;
      width: 22px;
      color: #6A737D;
      border-radius: 5px;
      text-align: center;

      img {
        height: 22px;
        width: 22px;
      }
    }
  }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
    .label {
      display: block;
      margin: 10px 0;
      font-size: 16px;
      line-height: 19px;
      font-weight: bold;
    }
    .total-box {
      margin: 15px -15px -15px -15px;
      padding: 15px;
      background: #ecf5ff;
      span {
        display: block;
        color: #616266;
        font-size: 14px;
      }
      .amount {
        font-size: 24px;
        color: #409eff;
        font-weight: bold;
      }
    }
  .total-amount {
    background: #f6f8fa;
    border-bottom: 0;
  }
  .flex-info {
    display: flex;
    justify-content: space-between;
    padding: 23px 15px;
    border-bottom: 1px solid #E1E4E8;

    span:first-child {
      color: #586069;
      font-size: 14px;
      font-weight: 500;
      width: 50%;
    }

    span:last-child {
      color: #24292E;
      font-size: 14px;
    }
    .flex-column{
      p{
        font-size: 14px;
        font-weight: 500;
        height: 24px;
      }
      .item_title{
        color: #586069;
      }
      .name{
        color: #0366D6;
      }
      .flag_tag{
        span{
          color: #C24E00;
          padding: 0px 8px;
          background: #FFFFFF;
          border: 1px solid #F66A0A;
          border-radius: 100px;
          height: 22px;
          display: inline-block;
          width: auto;
        }
      }
    }
  }
  .amount {
    color: #24292E;
    font-weight: bolder;
  }
</style>
